import { Component, Input, OnInit } from '@angular/core';
import { faHeart as faHeartEmpty } from '@fortawesome/free-regular-svg-icons';
import { faClock, faEuroSign, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { ImgOfferDefaultService } from 'app/shared/services/img-offer-default/img-offer-default.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-offer-preview-drag-drop',
  templateUrl: './offer-preview-drag-drop.component.html',
  styleUrls: ['./offer-preview-drag-drop.component.scss']
})
export class OfferPreviewDragDropComponent implements OnInit {
  @Input() offer: FullOffer;

  faClock = faClock;
  faMapMarkedAlt = faMapMarkedAlt;
  faHeartEmpty = faHeartEmpty;
  faEuroSign = faEuroSign;

  imgDefault: string;


  constructor(
    private imgOfferDefault: ImgOfferDefaultService,

  ) { }

  ngOnInit(): void {
    this.imgDefault = this.imgOfferDefault.imgDefault;
  }

}
